import React, {useEffect} from "react";

/**
 * Hook для обработки кликов вне переданного DOM-элемента.
 *
 * @param refs - масси ссылок на DOM-элемент, вне которого отслеживаются клики.
 * @param onClose - функция, вызываемая при клике вне элемента.
 */
export const useClickOutside = (
    refs: React.RefObject<HTMLElement | null>[],
    onClose: () => void
) => {
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const isOutside = refs.every(
                (ref) => ref.current && !ref.current.contains(event.target as Node)
            );

            if (isOutside) {
                onClose();
            }
        };


        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [refs, onClose]);
};
